<template>
    <div :class="{ 'conversations-component': true, 'for-account': accountNumber != undefined}">
        <div :class="{ 'conversations-header': true, 'has-selected': selectedConversation != undefined }">
            <h1 class="td-h2">Messages</h1>

            <a href="#" title="New message" @click.prevent="openNewConversation" >
                <icon type="solid" name="faPlus"></icon>
            </a>

            <select v-if="!accountNumber && canViewAll" name="selectedCsr" v-model="selectedCsr">
                <option v-for="csr in csrList" :key="csr.id" :value="csr.id">{{ csr.firstName }} {{ csr.lastName }}</option>
            </select>

            <a v-if="showNewWindow && !accountNumber" href="#" @click.prevent="newWindow" title="Open in new window">
                <icon type="solid" name="faUpRightFromSquare"></icon>
            </a>
        </div>
        <hr />

        <div :class="{ 'conversations-list': true, 'has-selected': selectedConversation != undefined, 'for-account': accountNumber != undefined }">
            <div v-if="conversationList.length == 0">
                <p>No active conversations available.</p>
            </div>

            <!-- conversation list item-->
            <div v-for="conversation in conversationList" :key="conversation.id" class="conversation-list-item">
                <div :class="{'conversation': true, 'selected': conversation.id == selectedConversation?.id }">
                    <div class="status">
                        <icon v-if="conversation.hasUnread" type="solid" name="faCircle"></icon>
                    </div>
                    <div class="content">
                        <span class="text" @click="selectConversation(conversation)">{{ conversation.externalAddress }}</span><br />
                        <a v-if="!accountNumber && hasAccount(conversation)" :href="getAccount(conversation)?.view ?? '#'" target="_blank" title="View Account">{{ getAccount(conversation)?.display }}</a><br v-if="!accountNumber && hasAccount(conversation)" />
                        <a v-if="hasUser(conversation)" :href="getUser(conversation)?.view ?? '#'" target="_blank" title="View User">{{ getUser(conversation)?.display }}</a><br v-if="hasUser(conversation)" />

                        <div class="content-footer">
                            <span class="time" @click="selectConversation(conversation)">{{ getTime(conversation.lastActivityDate) }}</span>
                            <span v-if="conversation.status != 0" class="status-badge td-badge primary">
                                Inactive
                            </span>
                            <span v-if="conversation.status == 0" class="status-badge td-badge secondary">
                                Active
                            </span>
                        </div>
                    </div>
                    <div class="action">
                        <a class="pl-1" href="#" @click.prevent="showConversationInfo(conversation)" title="Show information">
                            <icon type="solid" name="circleInfo"></icon>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{ 'messages-list': true, 'has-selected': selectedConversation != undefined, 'for-account': accountNumber != undefined }">
            <div v-if="selectedConversation != undefined" class="conversations-actions">
                <a href="#" @click.prevent="unselectConversation" title="Unselect conversation">
                    <icon type="solid" name="faSquareCheck"></icon>
                </a>

                <a class="pl-1" v-if="canMarkRead" href="#" @click.prevent="markRead" title="Mark as read">
                    <icon type="solid" name="faEnvelope"></icon>
                </a>
                <a class="pl-1" v-if="canMarkUnread" href="#" @click.prevent="markUnread" title="Mark as Unread">
                    <icon type="solid" name="faEnvelopeOpen"></icon>
                </a>

                <div class="pl-2" v-if="canAssign">
                    <select name="assignToCsr" v-model="assignToCsr">
                        <option v-if="!assignToCsr" :value="undefined">--- Select a CSR ---</option>
                        <option v-for="csr in csrList" :key="csr.id" :value="csr.id">{{ csr.firstName }} {{ csr.lastName }}</option>
                    </select>
                </div>
                <div v-if="!canAssign"></div>

                <a v-if="canAssign" href="#" @click.prevent="assignCsr" title="Assign to CSR">
                    <icon type="solid" name="faSquareCaretRight"></icon>
                </a>

                <a class="pl-1" href="#" @click.prevent="showConversationInfo(selectedConversation)" title="Show information">
                    <icon type="solid" name="circleInfo"></icon>
                </a>

                <a class="pl-2" v-if="canClose" href="#" @click.prevent="close" title="End conversation">
                    <icon type="solid" name="faCommentSlash"></icon>
                </a>
            </div>
            <div v-if="selectedConversation" class="messages" ref="messages">
                <div v-if="showMessageLoader">
                    <span v-if="messagesLoading"><icon type="solid" name="faSpinner" spin></icon></span>
                    <a href="#" v-if="!messagesLoading" @click.prevent="loadPrevious">Load Previous</a>
                </div>
                <div v-if="previous" v-for="message in previous.messages" :class="{ 'message': true, 'outbound': message.direction == 1 }">
                    <div v-if="message.media.length > 0" class="files">
                        <template v-for="file in message.media">
                            <div v-if="isImage(file)" class="image">
                                <a :href="file" target="_blank" title="Image"><img :src="file" /></a>
                            </div>
                            <div v-if="!isImage(file) && isFileSupported(file)" class="file">
                                <a :href="file" target="_blank" title="File">{{ getFileName(file) }}</a>
                            </div>
                            <div v-if="!isImage(file) && !isFileSupported(file)" class="file">
                                <icon @click.prevent="copyToClipboard(file)" type="regular" name="faCopy" aria-hidden="true" class="td-link secondary"></icon>  Unsupported File: {{ getFileName(file) }}
                            </div>
                        </template>
                    </div>
                    <div class="content">
                        <span v-if="message.body.length > 0" class="text" v-html="getMessageText(message)"></span><br v-if="message.body.length > 0" />
                        <span class="time">{{ getTime(message.date) }}</span>
                    </div>
                </div>
                <hr />
                <div v-for="message in selectedConversation.messages" :class="{ 'message': true, 'outbound': message.direction == 1 }">
                    <div v-if="message.media.length > 0" class="files">
                        <template v-for="file in message.media">
                            <div v-if="isImage(file)" class="image">
                                <a :href="file" target="_blank" title="Image"><img :src="file" /></a>
                            </div>
                            <div v-if="!isImage(file) && isFileSupported(file)" class="file">
                                <a :href="file" target="_blank" title="File">{{ getFileName(file) }}</a>
                            </div>
                            <div v-if="!isImage(file) && !isFileSupported(file)" class="file">
                                <icon @click.prevent="copyToClipboard(file)" type="regular" name="faCopy" aria-hidden="true" class="td-link secondary"></icon>  Unsupported File: {{ getFileName(file) }}
                            </div>
                        </template>
                    </div>
                    <div class="content">
                        <span v-if="message.body.length > 0" class="text" v-html="getMessageText(message)"></span><br v-if="message.body.length > 0" />
                        <span class="time">{{ getTime(message.date) }}</span>
                    </div>
                </div>
            </div>
            <div v-if="canMessage" class="message-input">
                <div class="new-message-data">
                    <textarea v-model="message" placeholder="Type a message ..." cols="3" :disabled="isLoading"></textarea>

                    <div v-if="showFileInput" class="file-input">
                        <label for="fileUpload"><icon name="faFileArrowUp" type="solid"></icon>{{ fileLabel }}</label>
                        <input ref="fileInput" id="fileUpload" @change="handleFileChange" type="file" style="display: none" :accept="acceptedFileTypes" :disabled="isLoading" />
                    </div>

                    <div v-if="errorMessage" class="td-banner danger dismissible">
                        <icon name="faTriangleExclamation" type="solid"></icon>
                        {{ errorMessage }}
                        <icon name="faXmark" type="solid" @click="errorMessage = undefined"></icon>
                    </div>
                </div>

                <div class="new-message-button">
                    <div></div>
                    <div>
                        <button @click.prevent="toggleMessageOptions" class="td-btn secondary-outlined messageSelector" title="Options" :disabled="isLoading">
                            <icon class="messageIcon" :name="sendMessageIcon" type="solid"></icon>
                            <icon class="messageOption" name="faCaretDown" type="solid"></icon>
                        </button>
                        <transition name="layoutdropdown">
                            <div v-if="showMessageOptions" class="options-list">
                                <a class="item td-btn" href="#" @click.prevent="selectMessage" title="Send Message" aria-label="Send Message">
                                    <icon name="faMessage" type="solid"></icon> Message
                                </a>
                                <a class="item td-btn" href="#" @click.prevent="selectPDF" title="Send PDF File" aria-label="Send PDF File">
                                    <icon name="faFilePdf" type="solid"></icon> PDF File
                                </a>
                                <a class="item td-btn" href="#" @click.prevent="selectImage" title="Send Image" aria-label="Send Image">
                                    <icon name="faImage" type="solid"></icon> Image
                                </a>
                            </div>
                        </transition>
                        <button @click.prevent="sendMessage" class="td-btn secondary-outlined" :title="messageType" :disabled="isLoading">
                            <span>{{ messageType }}</span>
                        </button>
                    </div>
                </div>

            </div>
        </div>
        <transition name="modal">
            <modal class="td-bg-color" v-if="conversationInfo" @close="closeConversationInfo" hide-footer>
                <div v-if="infoLoading" class="conversationInfo td-text-center">
                    <icon class="loader" type="solid" name="faSpinner" spin></icon>
                </div>
                <div v-if="!infoLoading" class="conversationInfo">
                    <div class="items-container td-card rounded px-0 td-mx-auto">
                        <h3 class="td-text-uppercase td-text-center td-h5 td-text-subdued mb-0">{{ conversationInfo.internalAddress }} to {{ conversationInfo.externalAddress }}</h3>
                        <div class="item full">
                            <label class="td-text-bold">
                                Status:
                            </label>
                            <span>{{ TextConversationStatus[conversationInfo.status] }}</span>
                        </div>
                        <div class="item full">
                            <label class="td-text-bold">
                                Type:
                            </label>
                            <span>{{ SmsMessageType[conversationInfo.type] }}</span>
                        </div>
                        <div class="item full">
                            <label class="td-text-bold">
                                Assigned To:
                            </label>
                            <span>{{ getCsrDisplay(conversationInfo.assignedCsr) }}</span>
                        </div>
                        <div class="item full">
                            <label class="td-text-bold">
                                Started:
                            </label>
                            <span>{{ getTime(conversationInfo.startDate) }}</span>
                        </div>
                        <div class="item full">
                            <label class="td-text-bold">
                                Last Activity:
                            </label>
                            <span>{{ getTime(conversationInfo.lastActivityDate) }}</span>
                        </div>
                    </div>

                    <div class="items-container td-card rounded px-0 td-mx-auto">
                        <h3 class="td-text-uppercase td-text-center td-h5 td-text-subdued mb-0">Related Account</h3>
                        <div class="item full">
                            <label class="td-text-bold">
                                Account:
                            </label>
                            <a v-if="hasAccount(conversationInfo)" :href="getAccount(conversationInfo)?.view ?? '#'" target="_blank" title="View Account">{{ getAccount(conversationInfo)?.display }}</a>
                            <span v-if="!hasAccount(conversationInfo)">Unassigned</span>
                        </div>
                        <div class="item full">
                            <label class="td-text-bold">
                                User:
                            </label>
                            <a v-if="hasUser(conversationInfo)" :href="getUser(conversationInfo)?.view ?? '#'" target="_blank" title="View User">{{ getUser(conversationInfo)?.display }}</a>
                            <span v-if="!hasUser(conversationInfo)">Unassigned</span>
                        </div>
                    </div>

                    <div v-if="infoCanAssign" class="items-container td-card rounded px-0 td-mx-auto">
                        <h3 class="td-text-uppercase td-text-center td-h5 td-text-subdued mb-0">Assign Conversation</h3>
                        <div class="item full">
                            <label class="td-text-bold">
                                Account #:
                            </label>
                            <input type="number" v-model="infoSelectedAccount" />
                        </div>
                        <div v-if="infoUserLookups.length > 0 && (!infoSelectedAccount || infoSelectedAccount.length == 0)" class="item full">
                            <label class="td-text-bold">
                                User:
                            </label>
                            <select v-model="infoSelectedUser">
                                <option v-for="user in infoUserLookups" :value="user.id">{{ user.display }}</option>
                            </select>
                        </div>
                        <div class="td-banner danger dismissible" v-if="infoAssignError">
                            <icon name="faCircleExclamation" type="solid"></icon>
                            <p>{{ infoAssignError }}</p>
                            <icon name="faXmark" type="solid" @click="infoAssignError = undefined"></icon>
                        </div>
                        <div class="item full td-text-right">
                            <button @click.prevent="assignConversation" class="td-btn primary">Assign</button>
                        </div>
                    </div>
                </div>
            </modal>
        </transition>

        <transition name="modal">
            <modal v-if="newMessageDisplay" class="td-bg-color" @close="closeNewConversation" hide-footer>
                <new-conversation @close="closeNewConversation" :account-id="accountId"></new-conversation>
            </modal>
        </transition>
    </div>
</template>

<script>
import script from './Conversations';
    export default script;</script>

<style lang="less">
    @import './Conversations.less';
</style>